import { DEFAULT_CHAPTERS_CONFIG } from "./chapters";
class VideoChapters {
    constructor(_ele, _config, _svp) {
        this.ele = _ele; // Player module
        this.chapters = _config; // chapters
        this.svPlayer = _svp; // streaming video player
        this.autoMenuTimer = undefined;
        this.subscriptions = [];
    }

    renderChapters() {
        console.log('VC: Render HTML called----');
        this.enhanceChaptersList();
        this.ele = document.querySelector(this.ele);
        const chaptersList = this.getChaptersList();
        const Headerhtml = this.getHeaderHTMLContent();
        let chaptersPlugInCon = document.createElement('div');
        chaptersPlugInCon.setAttribute('class', 'chapters-plugin-container');
        const chaptersPlugInConHtml = `
            <div class="chapters">
                <button class="chapters-tab">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" fill="none"><path stroke="#fff" stroke-linecap="round" stroke-width="1.5" d="M.75 13h16.5M.75 7h16.5M.75 1h8.5"></path>
                    </svg>
                </button>
                <div class="chapters-menu">
                    <div class="components-container">
                        <div class="heading">
                            ${Headerhtml}
                        </div>
                        <div class="chapters-list">
                            ${chaptersList}
                        </div>
                    </div>
                </div>
            </div>
        `;
        chaptersPlugInCon.innerHTML = chaptersPlugInConHtml;
        const tarEle = this.ele.querySelector('.streaming-video-player .amp-video');
        tarEle.parentNode.insertBefore(chaptersPlugInCon, tarEle);
    }

    getHeaderHTMLContent() {
        const { "ui-configs": uiConfigs } = this.chapters;
        const { heading, "hide-icon": hideIcon } = uiConfigs.menu;
        const { "html-content": headerTitle } = heading;
        const { "use-default": useDefault, "html-content": hideIconContent } = hideIcon;

        const hideContent = useDefault ? '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"><path fill="#fff" fill-rule="evenodd" d="M0 9a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 9Z" clip-rule="evenodd"></path></svg>'
            : '<span>' + hideIconContent + '</span>';
        const Headerhtml = `<div class="components-container"><h5>${headerTitle}</h5><button class="hide-menu">${hideContent}</button></div>`
        return Headerhtml;
    }

    getChaptersList() {
        const { items } = this.chapters;
        let ulList = "<ul>";
        items.forEach(item => {
            ulList += `<li class="chapter-item" data-current="false">
                <div class="components-container">
                    <div class="start-time"><span>${item.startTime}</span></div>
                    <div class="chapter-name"><span>${item.chapterName}</span></div>
                </div>
            </li>`;
        });
        ulList += '</ul>';
        return ulList;
    }

    addEventListenersForChaptersMenuTab() {
        const self = this;
        const { "ui-configs": uiConfigs } = this.chapters;
        const { "hide-on-chapter-click": hideMenuOnClick } = uiConfigs.menu;
        const chapterItems = self.ele.querySelectorAll('.chapters-plugin-container .chapters-list .chapter-item');
        chapterItems.forEach(element => {
            element.addEventListener('click', function (evt) {
                // Jump Video player to chapter startTime
                let currentInd = [...chapterItems].indexOf(this);
                if (currentInd != -1) {
                    self.activateChapter(currentInd);
                    let currentIndData = self.chapters.items[currentInd];
                    if (currentIndData != undefined) {
                        window.player.mediaElement.currentTime = currentIndData.startTimeInSecs;
                        wmdPageLink(`media-ctl_ch${currentInd + 1}`, this);
                    }
                }

                if (hideMenuOnClick) self.ele.querySelector('.chapters-plugin-container .chapters').classList.remove('active');
            })
        })

        const menuButtons = self.ele.querySelectorAll('.chapters-plugin-container button');
        menuButtons.forEach(element => {
            element.addEventListener('click', function (evt) {
                // show/hide Menu & Tab              
                if (this.classList.contains('hide-menu')) {
                    clearTimeout(self.autoMenuTimer);
                    self.ele.querySelector('.chapters-plugin-container .chapters').classList.remove('active');
                    wmdPageLink(`media-ctl_toc-close`, this);
                }
                else if (this.classList.contains('chapters-tab')) {
                    clearTimeout(self.autoMenuTimer);
                    self.ele.querySelector('.chapters-plugin-container .chapters').classList.add('active');
                    wmdPageLink(`media-ctl_toc-open`, this);
                }
            })
        })
    }

    addEventListenersForSVP() {
        const { "ui-configs": uiConfigs, items } = this.chapters;
        const { "always-visible": alwaysVisible } = uiConfigs;
        const { "enable": alwaysVisibleEnable, "auto-open": autoOpen } = alwaysVisible;
        const { "enable": autoOpenEnable, "timer": autoOpenTime, "auto-hide": autoHide } = autoOpen;
        const { "enable": autoHideEnable, "timer": autoHideTime } = autoHide;

        const { ele, svPlayer } = this;
        if (alwaysVisibleEnable) ele.querySelector('.chapters-plugin-container .chapters').classList.add('alwaysVisible');

        if (autoOpenEnable) {
            this.autoMenuTimer = setTimeout(() => {
                ele.querySelector('.chapters-plugin-container .chapters').classList.add('active');
                const menuCon = ele.querySelector('.chapters-plugin-container button.chapters-tab');
                wmdPageLink(`media-ato_toc-open`, menuCon);
                clearTimeout(this.autoMenuTimer);
                if (autoHideEnable) {
                    this.autoMenuTimer = setTimeout(() => {
                        ele.querySelector('.chapters-plugin-container .chapters').classList.remove('active');
                        const closeCon = ele.querySelector('.chapters-plugin-container button.hide-menu');
                        wmdPageLink(`media-ato_toc-close`, closeCon);
                    }, autoHideTime);
                }
            }, autoOpenTime);
        }

        this.isRenderMarkers = true;
        let timeupdate$ = svPlayer.AmpEventsSources["timeupdate"].subscribe(_event => {
            if (this.isRenderMarkers) this.renderMarkersOnProgressBar();
            this.checkAndUpdateActiveChapter();
        });
        let mediachange$ = svPlayer.AmpEventsSources["mediachange"].subscribe(_event => {
            if (_event.videoId != window.player.media.metadata.videoId) this.clearCompOnUnMount();
        });
        this.subscriptions = [timeupdate$, mediachange$];
    }

    activateChapter(_ind) {
        if (_ind != undefined) {
            let allItems = this.ele.querySelectorAll('.chapters .chapter-item');
            if (!allItems[_ind].classList.contains('active')) {
                let activeEle = this.ele.querySelectorAll('.chapters .chapter-item.active');
                activeEle.forEach((i) => { i.classList.remove('active') });
                allItems[_ind].classList.add('active');
            }
        }
    }

    convertMMSSToSecs(input) {
        let secs = undefined;
        if (input && typeof input === 'string') {
            const inputArr = input.split(':');
            secs = inputArr.length > 2 ? (Number(inputArr[0]) * 60 * 60 + Number(inputArr[1]) * 60 + Number(inputArr[2])) : (Number(inputArr[0]) * 60 + Number(inputArr[1]));
        }
        return secs;
    }

    clearCompOnUnMount() {
        clearTimeout(this.autoMenuTimer);
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        })
        this.subscriptions = [];
        if (this.ele) this.ele.querySelector('.chapters-plugin-container').remove();
    }

    checkAndUpdateActiveChapter() {
        let currentInd;
        const { items } = this.chapters;
        let startEndTimes = items.map((item) => {
            return { "startTime": item.startTimeInSecs, "endTime": item.endTimeInSecs };
        })
        for (let i = 0; i < startEndTimes.length; i++) {
            if (i + 1 == startEndTimes.length) {
                currentInd = i;
                break;
            }
            else {
                const startTime = startEndTimes[i].startTime;
                let endTime = startEndTimes[i].endTime;
                if (typeof endTime !== 'Number') endTime = startEndTimes[i + 1].startTime;

                let currentPlayTime = Math.floor(window.player.currentTime);
                if (startTime <= currentPlayTime && currentPlayTime < endTime) {
                    currentInd = i;
                    break;
                }
            }
        }
        if (currentInd != undefined) {
            this.activateChapter(currentInd);
        }
    }

    renderMarkersOnProgressBar() {
        const { items, "ui-configs": uiConfigs } = this.chapters;
        const isEnableMarkers = uiConfigs.markers && uiConfigs.markers.enable;
        const { duration } = window.player;
        if (!isEnableMarkers) {
            this.isRenderMarkers = undefined;
            return;
        }
        if (duration) this.isRenderMarkers = undefined;
        else return;
        let ampSlider = this.ele.querySelector('.amp-slide-in-out.amp-slider');
        let markersEle = document.createElement('div');
        markersEle.setAttribute('class', `chapters-markers ${isEnableMarkers ? 'active' : ''}`);
        let markersHtml = '';
        items.forEach((item, i) => {
            const { startTimeInSecs } = item;
            const leftPercent = (startTimeInSecs / duration) * 100;
            markersHtml += `<div class='marker ch${i + 1}' style='left: ${leftPercent}%'></div>`;
        });
        markersEle.innerHTML = markersHtml;
        ampSlider.append(markersEle);
        let chapterMarkers = this.ele.querySelectorAll('.chapters-markers .marker');
        chapterMarkers.forEach((element) => {
            element.addEventListener('click', function (evt) {
                evt.preventDefault();
                evt.stopPropagation();
                const leftValue = Number(this.style.left.replace('%', ''));
                const markerStartTime = (leftValue / 100) * duration;
                window.player.mediaElement.currentTime = Math.floor(markerStartTime);
            })
        })
    }

    enhanceChaptersList() {
        // Setting default props if any props misses to setup
        const { "ui-configs": uiConfigs, items } = this.chapters;
        let enhancedUIConfig = Object.assign({}, DEFAULT_CHAPTERS_CONFIG["ui-configs"]);
        if (typeof uiConfigs === 'object') {
            const { "always-visible": alwaysVisible, menu, markers } = uiConfigs;
            let _alwaysVisible = {}, _menu = {}, _markers = {};
            if (typeof alwaysVisible === 'object') {
                const _dAv = DEFAULT_CHAPTERS_CONFIG["ui-configs"]["always-visible"];
                const { "auto-open": autoOpen } = alwaysVisible;
                _alwaysVisible = {
                    "enable": alwaysVisible.enable,
                    "auto-open": {
                        "enable": typeof autoOpen === 'object' && typeof autoOpen.enable != 'undefined' ? autoOpen.enable : _dAv["auto-open"].enable,
                        "timer": typeof autoOpen === 'object' && typeof autoOpen.timer != 'undefined' ? autoOpen.timer : _dAv["auto-open"].timer,
                        "auto-hide": {
                            "enable": typeof autoOpen === 'object' && typeof autoOpen["auto-hide"] === 'object' && typeof autoOpen["auto-hide"].enable != 'undefined' ? autoOpen["auto-hide"].enable : _dAv["auto-open"]["auto-hide"].enable,
                            "timer": typeof autoOpen === 'object' && typeof autoOpen["auto-hide"] === 'object' && typeof autoOpen["auto-hide"].timer != 'undefined' ? autoOpen["auto-hide"].timer : _dAv["auto-open"]["auto-hide"].timer,
                        }
                    }
                }
            }
            if (typeof menu === 'object') {
                const _dMenu = DEFAULT_CHAPTERS_CONFIG["ui-configs"]["menu"];
                _menu = {
                    "hide-on-chapter-click": menu.enable,
                    "heading": {
                        "enable": typeof menu["heading"] === 'object' && typeof menu["heading"]["enable"] != "undefined" ? menu["heading"]["enable"] : _dMenu["heading"]["enable"],
                        "html-content": typeof menu["heading"] === 'object' && typeof menu["heading"]["html-content"] != "undefined" ? menu["heading"]["html-content"] : _dMenu["heading"]["html-content"]
                    },
                    "hide-icon": {
                        "use-default": typeof menu["hide-icon"] === 'object' && typeof menu["hide-icon"]["use-default"] != "undefined" ? menu["hide-icon"]["use-default"] : _dMenu["hide-icon"]["use-default"],
                        "html-content": typeof menu["hide-icon"] === 'object' && typeof menu["hide-icon"]["html-content"] != "undefined" ? menu["hide-icon"]["html-content"] : _dMenu["hide-icon"]["html-content"]
                    }
                }
            }
            if (typeof markers === 'object') {
                const _dMarkers = DEFAULT_CHAPTERS_CONFIG["ui-configs"]["markers"];
                _markers = { enable: typeof markers["enable"] != "undefined" ? markers["enable"] : _dMarkers["enable"] }
            }

            enhancedUIConfig = Object.assign({}, { "always-visible": _alwaysVisible, "menu": _menu, "markers": _markers });
        }
        this.chapters["ui-configs"] = Object.assign({}, enhancedUIConfig);

        let updatedItems = items.map((i) => {
            const startTimeInSecs = this.convertMMSSToSecs(i.startTime);
            const endTimeInSecs = this.convertMMSSToSecs(i.endTime);
            return Object.assign({}, i, { startTimeInSecs: startTimeInSecs, endTimeInSecs: endTimeInSecs });
        })
        this.chapters.items = [...updatedItems];
    }

    init() {
        console.log('VC: Init called -- ', this);
        const { ele, svPlayer, chapters } = this;
        if (ele && svPlayer && typeof chapters === 'object' && chapters.enable) {
            try {
                this.renderChapters();
                this.addEventListenersForChaptersMenuTab();
                this.addEventListenersForSVP();
            }
            catch (error) {
                console.error('Warning: Some portion of Video chaptering code failed to execute.', error)
            }
        }
    }
}

export { VideoChapters } 